import Member from '../Member';
import MemberContractState from '../MemberContractState';

export default class WaitListEntry {
    static fromData(data) {
        if (!data) {
            return;
        }

        const waitListEntry = new WaitListEntry();

        waitListEntry.id = data.id || null;
        waitListEntry.appointmentSeriesId = data.appointmentSeriesId || null;
        waitListEntry.offeringId = data.offeringId || null;
        waitListEntry.createdAt = data.createdAt || null;
        waitListEntry.deletedAt = data.deletedAt || null;
        waitListEntry.informedAt = data.informedAt || null;
        waitListEntry.notificationsSentAt = data.notificationsSentAt || null;
        waitListEntry.start = data.start || null;
        waitListEntry.member = Member.fromData(data.member);
        waitListEntry.reservedByMember = data.reservedByMember;
        waitListEntry.priority = data.priority;
        waitListEntry.status = data.status;
        waitListEntry.canEdit = data.canEdit;
        waitListEntry.canViewShortProfile = data.canViewShortProfile;
        waitListEntry.appointmentTitle = data.appointmentTitle;
        waitListEntry.appointmentStart = data.appointmentStart;
        waitListEntry.isCourse = data.isCourse;
        waitListEntry.isGeneric = data.isGeneric;
        waitListEntry.checked = false;
        waitListEntry.attendeeStatus = data.attendeeStatus;

        waitListEntry.member.contractState = waitListEntry.member.contractState
            ? new MemberContractState(
                    waitListEntry.member.contractState.status,
                    waitListEntry.member.contractState.contractType,
                )
            : null;

        return waitListEntry;
    }
}
